import eCreditFetch from './acc_interceptor.ts';
import ServiceResponse from "@/types_and_interfaces/service_response_interface.ts";
import API_CLS from "@/utils/api.ts";
import CommonClass from "@/utils/common.ts";
import {getCRSFToken} from "@/utils/cookies.ts";
import {MpassAuthType} from "@/types_and_interfaces/types.ts";
import {country_code} from "@/utils/constants.ts";
import * as Sentry from "@sentry/react";


export const auth_req = () => {
   
    const email_st_1 = async (email:string, token?:string) => {
        let response:ServiceResponse = {
            error: false,
        };

        if(!email) return
        
        try {

            const request = await eCreditFetch(API_CLS.account.email_1, {
                method: API_CLS.methods.Post,
                body: JSON.stringify({email}),
                headers: token ? {
                    "X-ReCaptcha-Token": token
                } : {}
            });
            response.status = request.status
            const body = await request.json();
            
            if(typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body
            } else {
                response.error = true
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "auth", action: "login_email_step1" } });
            response.error = true;

            return response;
        }
    }

    const email_st_2 = async (otp:string, email:string, token?:string ) => {
        let response:ServiceResponse = {
            error: false,
        };
        
        try {
            let data:any = {}
            
            if(otp)  data["otp"] = otp
            if(email)  data["email"] = email
            
            
            const request = await eCreditFetch(API_CLS.account.email_2, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),
                headers: token ? {
                    "X-ReCaptcha-Token": token
                } : {}
            })
            
            response.status = request.status
            const body = await request.json();
            
            if(typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok" && request.status === 200) {
                response.response = body
            } else {
                response.error = true
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "auth", action: "login_email_step2" } });
            response.error = true;

            return response;
        }
    }

    const phone_st_1 = async (phone:string, token?:string) => {
        let response:ServiceResponse = {
            error: false,
        };
        
        if(!phone) return
        
        // REMOVE SPACES
        
        const ph = CommonClass.phoneFormater(phone)

        try {
            const request = await eCreditFetch(API_CLS.account.phone_1, {
                method: API_CLS.methods.Post,
                body: JSON.stringify({phone: ph}),
                headers: token ? {
                    "X-ReCaptcha-Token": token
                } : {}
            });

            response.status = request.status
            const body = await request.json();

            if(typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body
            } else {
                response.error = true
            }

            return response;

        } catch (error) {
            Sentry.captureException(error, { tags: { section: "auth", action: "login_phone_step1" } });
            response.error = true;

            return response;
        }
    }

    const phone_st_2 = async ( otp:string, phone:string , token?:string) => {
        let response:ServiceResponse = {
            error: false,
        };
        
        const ph = CommonClass.phoneFormater(phone)
        
        try {
            let data:any = {}
            
            if(otp)  data["otp"] = otp
            if(ph)  data["phone"] = ph
            
            const request = await eCreditFetch(API_CLS.account.phone_2, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),
                headers: token ? {
                    "X-ReCaptcha-Token": token
                } : {}
            })
            
            response.status = request.status
            const body = await request.json();
            
            if(typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok" && request.status === 200) {
                response.response = body
            } else {
                response.error = true
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "auth", action: "login_phone_step2" } });
            response.error = true;

            return response;
        }
    }

    const check_phone = async (phone:string, token?:string) => {
        let response:ServiceResponse = {
            error: false,
        };

        if(!phone) return
        const ph = CommonClass.phoneFormater(phone)

        try {
            const request = await eCreditFetch(API_CLS.account.check_phone, {
                method: API_CLS.methods.Post,
                body: JSON.stringify({phone: ph}),
                headers: token ? {
                    "X-ReCaptcha-Token": token
                } : {}
            });

            response.status = request.status
            const body = await request.json();

            if(typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body
            } else {
                response.error = true
            }

            return response;

        } catch (error) {
            Sentry.captureException(error, { tags: { section: "auth", action: "check_phone" } });
            response.error = true;

            return response;
        }
    }

    const mpass = async (r_token:any, x:MpassAuthType) => {
        
        try {
            let url = import.meta.env.VITE_API_URL + API_CLS.account[x === "individual" ? "mpass_individ" : "mpass_company"]
            const form = document.createElement('form');
            form.setAttribute('method', 'post');
            form.setAttribute('action', url);
            
            if (r_token) {
                const input1 = document.createElement('input');
                input1.setAttribute('type', 'hidden');
                input1.setAttribute('name', 'x-recaptcha-token');
                input1.setAttribute('value', r_token);
                form.appendChild(input1);
            }
            
            await fetch(import.meta.env.VITE_API_URL + "/api/web/csrf/refresh", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
                credentials: 'include'
            })
            
            const csrfToken = getCRSFToken();
            
            if (typeof csrfToken === "string") {
                const input2 = document.createElement('input');
                input2.setAttribute('type', 'hidden');
                input2.setAttribute('name', 'x-csrf-token');
                input2.setAttribute('value', csrfToken);
                form.appendChild(input2);
            }
            
            form.style.display = 'none';
            document.body.appendChild(form);
            
            form.submit();

            form.remove();
            
        } catch (e) {
            Sentry.captureException(e, { tags: { section: "auth", action: "mpass" } });
        }
    }
    
    const logout = async () => {
        await eCreditFetch(API_CLS.account.logout, {
            method: API_CLS.methods.Post,
        });
    }
    
    return {
        email_st_1,
        email_st_2,
        phone_st_1,
        phone_st_2,
        check_phone,
        logout,
        mpass
    }
}

export const profile_api = () => {
    const set_pwd = async ( pwd:string , r_token?:string) => {
        let response:ServiceResponse = {
            error: false,
        };
        
        try {
            let data:any = {}
            
            if(pwd) data["passcode"] = pwd
            
            const request = await eCreditFetch(API_CLS.account.set, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            })
            
            response.status = request.status
            const body = await request.json();
            
            if(typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok" && request.status === 200) {
                response.response = body
            } else {
                response.error = true
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "profile", action: "set_password" } });
            response.error = true;

            return response;
        }
    }

    const auth = async (pwd:string,  r_token?:string, user_id?: string ) => {
        
        let response:ServiceResponse = {
            error: false,
        };

        const data = {
            ...(user_id && { user_id: user_id }),
            ...(pwd && { passcode: pwd }),
        }

        try {
            // if(device_uid) data["device_uid"] = device_uid
            
            const request = await eCreditFetch(API_CLS.account.auth, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            })
            
            response.status = request.status
            const body = await request.json();
            
            if(typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok" && request.status === 200) {
                response.response = body
            } else {
                response.error = true
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "auth", action: "authenticate" } });
            response.error = true;

            return response;
        }
    }

    const get_me = async () => {
        let response:ServiceResponse = {
            error: false,
        };
        
        try {
            
            const request = await eCreditFetch(API_CLS.account.me, {
                method: API_CLS.methods.Get,
            })
            
            response.status = request.status
            const body = await request.json();
            
            if(typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok" && request.status === 200) {
                response.response = body
            } else {
                response.error = true
                response.response = body
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "profile", action: "get_me" } });
            response.error = true;

            return response;
        }
    }



    return {
        set_pwd,
        auth,
        get_me
    }
}

export const reset_pwd = () => {

    
    const by_email1 = async (email:string, r_token?:string) => {
        let response:ServiceResponse = {
            error: false,
        };
        
        if(!email) return
        
        try {
            
            const request = await eCreditFetch(API_CLS.account.reset_pwd_by_email1, {
                method: API_CLS.methods.Post,
                body: JSON.stringify({email}),
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            });
            
            response.status = request?.status
            const body = await request?.json();
            
            if(response.status === 200 && typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body
                response.message = "email_code_info_text1"
                
            } else if(response.status === 429) {
                response.message = "att_limit"
                
            } else {
                response.error = true
                response.message = "error_message"
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "password_reset", action: "reset_by_email_step1" } });
            response.error = true;

            return response;
        }
    }

    const by_email2 = async (data:any, r_token?:string) => {
        
        let response:ServiceResponse = {
            error: false,
        };
        
        if(typeof data !== "object" || (typeof data === "object" && !Object.keys(data).length) ) return
        
        try {
            
            const request = await eCreditFetch(API_CLS.account.reset_pwd_by_email2, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            });
            
            response.status = request.status
            const body = await request.json();
            
            if(response.status === 200 && typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body
                response.message = "success_pwd_reset"
                
            } else if(response.status === 429) {
                response.message = "att_limit"
                
            } else {
                response.error = true
                response.message = "wrong_data"
                
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "password_reset", action: "reset_by_email_step2" } });
            response.error = true;
            return response;
        }
    }

    const by_phone1= async (phone:string, token?:string) => {
        let response:ServiceResponse = {
            error: false,
        };
        
        if(!phone) return
        
        try {
            
            const request = await eCreditFetch(API_CLS.account.reset_pwd_by_phone1, {
                method: API_CLS.methods.Post,
                body: JSON.stringify({phone}),
                headers: token ? {
                    "X-ReCaptcha-Token": token
                } : {}
            });
            
            response.status = request.status
            const body = await request.json();
            
            if(response.status === 200 && typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body
                response.message = "success"
            } else if(response.status === 400) {
                response.error = true
                response.message = "valid_nr_err"
            } else if(response.status === 400) {
            
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "password_reset", action: "reset_by_phone_step1" } });
            response.error = true;

            return response;
        }
    }

    const by_phone2 = async (data:any, r_token?:string) => {
        
        let response:ServiceResponse = {
            error: false,
        };
        
        if(typeof data !== "object" || (typeof data === "object" && !Object.keys(data).length) ) return
        
        try {
            
            const request = await eCreditFetch(API_CLS.account.reset_pwd_by_phone2, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            });
            
            response.status = request.status
            const body = await request.json();
            
            if(response.status === 200 && typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body
                response.message = "success_pwd_reset"
                
            } else if(response.status === 429) {
                response.message = "att_limit"
                
            } else {
                response.error = true
                response.message = "error_message"
                
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "password_reset", action: "reset_by_phone_step2" } });
            response.error = true;
            return response;
        }
    }

    return {
        by_email1,
        by_email2,
        by_phone1,
        by_phone2
    }
}

// Public reset password (for non-logged users - ResetPinPage)
export const public_reset_pwd = () => {

    const by_email1 = async (email: string, user_id: string, r_token?: string) => {
        let response: ServiceResponse = {
            error: false,
        };

        if (!email || !user_id) return response;

        try {
            const request = await eCreditFetch(API_CLS.account.public_reset_pwd_by_email1, {
                method: API_CLS.methods.Post,
                body: JSON.stringify({
                    email,
                    user_id
                }),
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            });

            response.status = request?.status;
            const body = await request?.json();

            if (response.status === 200 && typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body;
                response.message = "email_code_info_text1";
            } else if (response.status === 429) {
                response.message = "att_limit";
            } else {
                response.error = true;
                response.message = "valid_email_err";
            }

            return response;

        } catch (error) {
            Sentry.captureException(error, { tags: { section: "public_password_reset", action: "reset_by_email_step1" } });
            response.error = true;
            return response;
        }
    }

    const by_email2 = async (email: string, otp: string, passcode: string, user_id: string, r_token?: string) => {
        let response: ServiceResponse = {
            error: false,
        };

        if (!email || !otp || !passcode || !user_id) return response;

        try {
            const request = await eCreditFetch(API_CLS.account.public_reset_pwd_by_email2, {
                method: API_CLS.methods.Post,
                body: JSON.stringify({
                    passcode,
                    otp,
                    email,
                    user_id
                }),
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            });

            response.status = request.status;
            const body = await request.json();

            if (response.status === 200 && typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body;
                response.message = "success_pwd_reset";
            } else if (response.status === 429) {
                response.message = "att_limit";
            } else {
                response.error = true;
                response.message = "wrong_data";
            }

            return response;

        } catch (error) {
            Sentry.captureException(error, { tags: { section: "public_password_reset", action: "reset_by_email_step2" } });
            response.error = true;
            return response;
        }
    }

    const by_phone1 = async (phone: string, user_id: string, r_token?: string) => {
        let response: ServiceResponse = {
            error: false,
        };

        if (!phone || !user_id) return response;

        try {
            const request = await eCreditFetch(API_CLS.account.public_reset_pwd_by_phone1, {
                method: API_CLS.methods.Post,
                body: JSON.stringify({
                    phone,
                    user_id,
                    auto_fill: ""
                }),
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            });

            response.status = request.status;
            const body = await request.json();

            if (response.status === 200 && typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body;
                response.message = "success";
            } else if (response.status === 400) {
                response.error = true;
                response.message = "valid_nr_err";
            } else if (response.status === 429) {
                response.message = "att_limit";
            } else {
                response.error = true;
                response.message = "error_message";
            }

            return response;

        } catch (error) {
            Sentry.captureException(error, { tags: { section: "public_password_reset", action: "reset_by_phone_step1" } });
            response.error = true;
            return response;
        }
    }

    const by_phone2 = async (phone: string, otp: string, passcode: string, user_id: string, r_token?: string) => {
        let response: ServiceResponse = {
            error: false,
        };

        if (!phone || !otp || !passcode || !user_id) return response;

        try {
            const request = await eCreditFetch(API_CLS.account.public_reset_pwd_by_phone2, {
                method: API_CLS.methods.Post,
                body: JSON.stringify({
                    passcode,
                    otp,
                    phone,
                    user_id
                }),
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            });

            response.status = request.status;
            const body = await request.json();

            if (response.status === 200 && typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body;
                response.message = "success_pwd_reset";
            } else if (response.status === 429) {
                response.message = "att_limit";
            } else {
                response.error = true;
                response.message = "error_message";
            }

            return response;

        } catch (error) {
            Sentry.captureException(error, { tags: { section: "public_password_reset", action: "reset_by_phone_step2" } });
            response.error = true;
            return response;
        }
    }

    return {
        by_email1,
        by_email2,
        by_phone1,
        by_phone2
    }
}

export const edit_profile = () => {
    const email1 = async (new_email:string, r_token?:string) => {
        let response:ServiceResponse = {
            error: false,
        };
        
        if(!new_email) return
        
        try {
            
            const request = await eCreditFetch(API_CLS.account.edit_profile.email1, {
                method: API_CLS.methods.Post,
                body: JSON.stringify({new_email}),
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            });
            
            response.status = request?.status
            const body = await request?.json();
            
            if(response.status === 200 && typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body
                response.message = "email_code_info_text1"
                
            } else if(response.status === 429) {
                response.message = "att_limit"
                
            } else if(response.status === 423) {
                response.message = "action_locked"
                
            } else if(response.status === 400) {
                response.message = "valid_email_err"
                
            } else {
                response.error = true
                
                if(body.message.includes("exist")) {
                    response.message = "existent_email_err"
                } else {
                    response.message = "error_message"
                }
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "edit_profile", action: "change_email_step1" } });
            response.error = true;

            return response;
        }
    }

    const email2 = async (new_email:string, otp:string, r_token?:string) => {
        
        let response:ServiceResponse = {
            error: false,
        };
        
        if(!new_email || !otp) return
        
        try {
            
            const request = await eCreditFetch(API_CLS.account.edit_profile.email2, {
                method: API_CLS.methods.Post,
                body: JSON.stringify({
                    new_email,
                    otp
                }),
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            });
            
            response.status = request?.status
            const body = await request?.json();
            
            if(response.status === 200 && typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body
                response.message = "email_code_info_text2"
                
            } else if(response.status === 429) {
                response.message = "att_limit"
                
            } else if(response.status === 423) {
                response.message = "action_locked"
                
            } else if(response.status === 400) {
                response.message = "valid_email_err"
                
            } else {
                response.error = true
                response.message = "error_message"
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "edit_profile", action: "change_email_step2" } });
            response.error = true;

            return response;
        }
    }

    const phone1 = async (new_phone:string, r_token?:string) => {
        let response:ServiceResponse = {
            error: false,
        };
        
        if(!new_phone) return
        let ph = country_code + new_phone.replace(/\s+/g, '');
        
        try {

            const request = await eCreditFetch(API_CLS.account.edit_profile.phone1, {
                method: API_CLS.methods.Post,
                body: JSON.stringify({
                    new_phone: ph
                }),
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            });

            response.status = request?.status
            const body = await request?.json();

            if(response.status === 200 && typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body
                response.message = "number_code_info_text1"

            } else if(response.status === 429) {
                response.message = "att_limit"

            } else if(response.status === 423) {
                response.message = "action_locked"

            } else if(response.status === 400) {
                
                response.message = "valid_nr_err"

            } else {
                response.error = true
                
                if(body.message.includes("exist")) {
                    response.message = "existent_phone_err"
                } else {
                    response.message = "error_message"
                }
            }

            return response;

        } catch (error) {
            Sentry.captureException(error, { tags: { section: "edit_profile", action: "change_phone_step1" } });
            response.error = true;

            return response;
        }
    }

    const phone2 = async (new_phone:string, otp:string, r_token?:string) => {
        
        let response:ServiceResponse = {
            error: false,
        };
        
        if(!new_phone || !otp) return
        let ph = country_code + new_phone.replace(/\s+/g, '');
        
        try {
            
            const request = await eCreditFetch(API_CLS.account.edit_profile.phone2, {
                method: API_CLS.methods.Post,
                body: JSON.stringify({
                    new_phone: ph,
                    otp
                }),
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            });
            
            response.status = request?.status
            const body = await request?.json();
            
            if(response.status === 200 && typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body
                response.message = "number_code_info_text2"
                
            } else if(response.status === 429) {
                response.message = "att_limit"
                
            } else if(response.status === 423) {
                response.message = "action_locked"
                
            } else if(response.status === 400) {
                response.message = "valid_nr_err"
                
            } else {
                response.error = true
                response.message = "error_message"
                
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "edit_profile", action: "change_phone_step2" } });
            response.error = true;

            return response;
        }
    }

    return {
        email1,
        email2,
        phone1,
        phone2
    }
}

export const kyc = () => {
    
    const start_kyc = async () => {
    
    }
    
    const end_kyc = async () => {
    
    }
    
    // const doc_reader_verify = async (transactionId:string, transactionTag:string) => {
    //
    //     let response:ServiceResponse = {
    //         error: false,
    //     };
    //
    //     try {
    //         const request = await eCreditFetch(API_CLS.kyc.regula_verify, {
    //             method: API_CLS.methods.Post,
    //             body: JSON.stringify({
    //                 "transaction_id": transactionId,
    //                 "transaction_tag": transactionTag,
    //             }),
    //         })
    //
    //         response.status = request?.status
    //         const body = await request?.json();
    //
    //         if(response.status === 200 && typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
    //             response.response = body
    //
    //         } else if(response.status === 429) {
    //             response.message = "att_limit"
    //
    //         } else {
    //             response.error = true
    //             response.message = "error_message"
    //         }
    //     } catch (e){
    //         response.error = true;
    //
    //         return response;
    //     }
    //
    //
    // }

    const face_liveness_start = async () => {
        let response:ServiceResponse = {
            error: false,
        };

        try {
            const request = await eCreditFetch(API_CLS.kyc.face_liveness_start, {
                method: API_CLS.methods.Post,
            })

            response.status = request?.status
            const body = await request?.json();

            if(response.status === 200 && typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body

            } else if(response.status === 429) {
                response.message = "att_limit"

            } else {
                response.error = true
                response.message = "error_message"
            }

            return response

        } catch (e){
            Sentry.captureException(e, { tags: { section: "kyc", action: "face_liveness_start" } });
            response.error = true;

            return response;
        }
    }

    const face_liveness_finish = async (transaction_id:string) => {
        let response:ServiceResponse = {
            error: false,
        };

        try {

            const request = await eCreditFetch(API_CLS.kyc.face_liveness_finish, {
                method: API_CLS.methods.Post,
                body: JSON.stringify({
                    "transaction_id":transaction_id
                })
            })

            response.status = request?.status
            const body = await request?.json();

            if(response.status === 200 && typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body

            } else if(response.status === 429) {
                response.message = "att_limit"

            } else {
                response.error = true
                response.message = "error_message"
            }

            return response

        } catch (e){
            Sentry.captureException(e, { tags: { section: "kyc", action: "face_liveness_finish" } });
            response.error = true;

            return response;
        }
    }



    return {
        start_kyc,
        end_kyc,
        // doc_reader_verify,
        face_liveness_start,
        face_liveness_finish
    }
    
}

export const get_market_qr_codes = async (token?:string) => {
    let response:ServiceResponse = {
        error: false,
    };
    
    
    try {
        const request = await eCreditFetch(API_CLS.common.get_market_qr_codes, {
            method: API_CLS.methods.Post,
            headers: token ? {
                "X-ReCaptcha-Token": token
            } : {}
        });
        
        response.status = request?.status
        const body = await request.json();
        
        if(response.status === 200) {
            response.message = "ok"
            response.response = body
        } else {
            response.error = true
        }
        
        return response;
        
    } catch (error) {
        Sentry.captureException(error, { tags: { section: "common", action: "get_market_qr_codes" } });
        response.error = true;

        return response;
    }
}

export const user_update = async () => {
    let response:ServiceResponse = {
        error: false,
    };

    try {
        const request = await eCreditFetch(API_CLS.account.user_update, {
            method: API_CLS.methods.Post,
        });

        response.status = request?.status
        const body = await request.json();

        if(response.status === 200) {
            response.message = "ok"
            response.response = body
        } else {
            response.error = true
        }

        return response;

    } catch (error) {
        Sentry.captureException(error, { tags: { section: "profile", action: "user_update" } });
        response.error = true;

        return response;
    }
}